import Vue from "vue";

import Vuetify from "vuetify/lib";
import et from "vuetify/es5/locale/et";
import en from "vuetify/es5/locale/en";
Vue.use(Vuetify);

import colors from "vuetify/lib/util/colors";

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: colors.purple.base, // primary main
        primarylight: colors.purple.lighten4, // primary light
        primarydark: colors.purple.darken3, // primary dark
        // primary: colors.deepPurple.darken3, // primary main
        // primarylight: colors.deepPurple.base, // primary light
        // primarydark: colors.deepPurple.darken4, // primary dark
        secondary: colors.lightGreen.base, // secondary main
        secondarylight: colors.lightGreen.lighten4, // secondary light
        secondarydark: colors.lightGreen.darken3, // secondary dark
        anchor: colors.purple.base, // link

        // primary: "#ee44aa",
        // secondary: "#424242",
        // accent: "#82B1FF",
        // error: "#FF5252",
        // info: "#2196F3",
        // success: "#4CAF50",
        // warning: "#FFC107"
      },
    },
  },
  lang: {
    locales: { et },
    current: "et",
  },
});
